/**
 * 新しいメッセージ設計を使う予定の為、一時的なチャットメッセージユーティリティ関数
 * 今後は以下のような形で取り扱う予定です。
 * 例 ) { "type":"text", "text": "こんにちは！" }
 *
 * (realtimeAPIを使う場合は、新しいメッセージ設計を使わない想定です)
 */

/**
 * チャットメッセージ内の $$key$$ 形式を抽出する
 * @param text 抽出対象のテキスト
 * @returns 抽出されたキーの配列
 */
export const extractDollarKeys = (text: string): string[] => {
  if (!text) return [];

  const regex = /\$\$([^$]+?)\$\$/g;
  const keys: string[] = [];
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    const key = match[1];
    if (key) keys.push(key);
  }

  return keys;
};

/**
 * チャットメッセージ内に $$key$$ 形式が存在するかどうかをチェック
 * @param text チェック対象のテキスト
 * @returns 存在すれば true、存在しなければ false
 */
export const hasDollarKeys = (text: string): boolean => {
  if (!text) return false;
  const regex = /\$\$([^$]+?)\$\$/;
  return regex.test(text);
};

/**
 * テキストから $$key$$ の箇所すべてを削除する関数
 * @param text 処理対象のテキスト
 * @returns $$key$$ を完全に削除したテキスト
 */
export const removeDollarKeys = (text: string): string => {
  if (text === undefined || text === null) return "";
  return text.replace(/\$\$([^$]*)\$\$/g, "");
};
